import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import MatchingDetailsCard from "./matchingDetailsCard";
import MatchingDetailsLabelValue from "./matchingDetailsLabelValue";

const useStyles = makeStyles(() => ({
  cardContainer: {
    marginTop: 32,
    marginBottom: 32,
  },
}));

const MatchingDetailsSummaryCard = ({
  totalExperience = "",
  avgYearsPerCompany = "",
  highestEducation = "",
  major = "",
  mode,
}) => {
  const classes = useStyles({ mode });
  const LABEL_VALUES_MAP = [
    {
      label: "Total Experience",
      value: totalExperience ? `${totalExperience} yrs` : "-",
    },
    {
      label: "Avg. yrs/Company",
      value: avgYearsPerCompany ? `${avgYearsPerCompany} yrs` : "-",
    },
    {
      label: "Highest Education",
      value: `${highestEducation}${major ? ` (${major})` : ""}` || "-",
    },
  ];

  return (
    <MatchingDetailsCard
      title={"Summary"}
      rootClass={classes.cardContainer}
      mode={mode}
    >
      <Grid container>
        {LABEL_VALUES_MAP.map(({ label, value }) => (
          <Grid item xs={3} key={label}>
            <MatchingDetailsLabelValue
              mode={mode}
              label={label}
              value={value}
            />
          </Grid>
        ))}
      </Grid>
    </MatchingDetailsCard>
  );
};

export default MatchingDetailsSummaryCard;
